import Rellax from 'rellax'

// Center all the things!
var rellax = new Rellax('.rellax', {
  center: true
});
